import { render, staticRenderFns } from "./DM_transctionList.vue?vue&type=template&id=3a9ea771&"
import script from "./DM_transctionList.vue?vue&type=script&lang=js&"
export * from "./DM_transctionList.vue?vue&type=script&lang=js&"
import style0 from "./DM_transctionList.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports